import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { ErrorBoundary, Icon, Allocation } from 'components'
import { setGoalProp, setActiveGoal } from 'store/actions'
import { getRegularInvestments, getBalanceSavings } from 'store/selectors'

function Allocations(props) {
  const { location, goalList, setGoalProp, remaining } = props
  const editPanelClosed = !(
    location.pathname.includes('edit') || location.pathname.includes('profile')
  )
  return (
    <div className="allocations">
      <ErrorBoundary>
        <div>
          <div>
            <h5>ALLOCATIONS</h5>
            <button className="minimal" style={{ visibility: 'hidden' }}>
              <Icon name="settings-primary" small />
              OPTIMIZE
            </button>
          </div>
          <div>
            <div>
              <span>
                <strong>Savings Allocation</strong>
              </span>
              <span>{remaining}L Left</span>
            </div>
            <div>
              <span>Monthly Investment</span>
              <span>(starting at age)</span>
            </div>
          </div>
        </div>
        <div className={classnames({ 'edit-panel-closed': editPanelClosed })}>
          {goalList.map((goal, idx) => (
            <Allocation
              key={goal.id}
              icon={goal.icon}
              title={goal.title}
              allocation={goal.startingAllocation}
              maxAllocation={goal.maxStartingAllocation}
              monthly={goal.regularInvestment}
              active={goal.active}
              investStartAge={goal.investStartAge}
              handleUpdate={value =>
                setGoalProp(goal.id, 'startingAllocation', value)
              }
            />
          ))}
        </div>
      </ErrorBoundary>
    </div>
  )
}

export default connect(
  state => ({
    goalList: getRegularInvestments(state),
    remaining: getBalanceSavings(state),
  }),
  { setGoalProp, setActiveGoal }
)(Allocations)



// WEBPACK FOOTER //
// ./src/components/layout/Allocations.js